<nb-card style="min-width: 750px; min-height: 500px">
  <nb-card-header class="d-flex justify-content-between align-items-center">
    Select Members
    <button
      (click)="cancel()"
      type="button"
      class="btn-close"
      aria-label="Close"
    ></button>
  </nb-card-header>

  <nb-card-body>
    <!-- Search -->
    <div class="header-page">
      <nb-form-field>
        <nb-icon nbPrefix icon="search-outline"></nb-icon>
        <input
          type="text"
          nbInput
          [(ngModel)]="searchTerm"
          fieldSize="small"
          placeholder="Search by extension or name"
        />
      </nb-form-field>
    </div>

    <!-- Agents List -->
    <nb-list class="agents-list">
      <nb-list-item
        *ngFor="let agent of filteredAgents"
        (click)="toggleSelection(agent)"
      >
        <div class="d-flex align-items-center w-100">
          <nb-checkbox
            [checked]="isSelected(agent)"
            (click)="$event.stopPropagation()"
            (checkedChange)="toggleSelection(agent)"
            [disabled]="
              !isSelected(agent) && selectedAgents.length >= maxMembers
            "
          ></nb-checkbox>
          <div class="agent-info">
            <div class="agent-name">{{ agent.extension }}</div>
            <div class="agent-detail">{{ agent.fullName }}</div>
          </div>
        </div>
      </nb-list-item>
    </nb-list>
  </nb-card-body>

  <nb-card-footer class="d-flex justify-content-end">
    <button
      nbButton
      status="basic"
      class="me-2"
      size="small"
      (click)="cancel()"
    >
      Cancel
    </button>
    <button nbButton status="primary" size="small" (click)="confirm()">
      Confirm
    </button>
  </nb-card-footer>
</nb-card>
